import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

const fetchBuildVersion = async () => {
  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=build_version`,
  );
  return response.data;
};

const useBuildVersionQuery = (options = {}) => {
  return useQuery({
    queryKey: ["buildVersion"],
    queryFn: fetchBuildVersion,
    retry: false,
    ...options,
  });
};

export default useBuildVersionQuery;
